import React, { useState, useEffect } from 'react';
import { getToken, getUserData, isAuthenticated } from '../services/authService';

const UserLoginContext = React.createContext([{}, () => {}]);

const UserLoginProvider = (props) => {
    // Initialize state from localStorage if available
    const initializeState = () => {
        if (isAuthenticated()) {
            const token = getToken();
            const user = getUserData();

            if (token && user) {
                return {
                    Userid: user.email || "",
                    Email: user.email || "",
                    Fname: user.firstName || "",
                    Lname: user.lastName || "",
                    status: true,
                    role: user.role || "",
                    _id: user._id || "",
                    token: token,
                    cloudinary_upload: user.cloudinary_upload || "",
                    cloudinary_destory: user.cloudinary_destory || "",
                    apiKeyCloudinary: user.apiKeyCloudinary || "",
                    apiSecretKeyCloudinary: user.apiSecretKeyCloudinary || "",
                    apiKey: user.apiKey || ""
                };
            }
        }

        // Default empty state if not authenticated
        return {
            Userid: "",
            Email: "",
            Fname: "",
            Lname: "",
            status: false,
            role: "",
            _id: "",
            token: "",
            cloudinary_upload: "",
            cloudinary_destory: "",
            apiKeyCloudinary: "",
            apiSecretKeyCloudinary: "",
            apiKey: ""
        };
    };

    const [state, setState] = useState(initializeState());

    // Listen for storage changes (e.g., logout from another tab)
    useEffect(() => {
        const handleStorageChange = () => {
            const newState = initializeState();
            setState(newState);
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return (
        <UserLoginContext.Provider value={[state, setState]}>
            {props.children}
        </UserLoginContext.Provider>
    );
};

export { UserLoginContext, UserLoginProvider };
